module.exports = __webpack_public_path__ + "static/media/poiminta-alkaa.af2a5fdb.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/poiminta-alkaa.jpg
 ** module id = 372
 ** module chunks = 0
 **/